import { createSelector } from "reselect";
import { initialState } from "./reducer";
import { APP_PAGE_COMPOSER } from "./constants";

const selectState = (state) => state[APP_PAGE_COMPOSER] || initialState;

export const selectEditAppPage = () =>
  createSelector(selectState, (state) => state.get("editPage"));
export const selectExampleTile = () =>
  createSelector(selectState, (state) => state.get("exampleTile"));
